export const sliderData = [
    {
      image: "https://images.pexels.com/photos/298864/pexels-photo-298864.jpeg",
      heading: "Shoes Hub",
      desc: "Up to 30% off on all onsale proucts.",
    },
    {
      image: "https://images.pexels.com/photos/167703/pexels-photo-167703.jpeg",
      heading: "Women Fashion",
      desc: "Up to 30% off on all onsale proucts.",
    },
    {
      image: "https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg",
      heading: "Men Fashion",
      desc: "Up to 30% off on all onsale proucts.",
    },
    {
      image: "https://images.pexels.com/photos/4087475/pexels-photo-4087475.jpeg",
      heading: "Cool Gadgets",
      desc: "Up to 30% off on all onsale proucts.",
    },
  ];